import { extendObservable, action } from 'mobx';
import PasscodeHelper from '../tools/PasscodeHelper';

export const PasscodeType = {
  OneTime: "ONE_TIME",
  Weekly: "WEEKLY",
  Monthly: "MONTHLY",
  TimeFrame: "TIME_FRAME",
  NoLimit: "NO_LIMIT",
};

export class Passcode {
  constructor(props = {}) {
    let {
      id = "",
      userId = "",
      propertyId = "",
      name = "My passcode",
      passcode = PasscodeHelper.generateRandomPasscode(),
      enabled = true,
      notifySms = false,
      notifyEmail = false,
      type = PasscodeType.NoLimit, // PasscodeType
      startTime = "",
      endTime = "",
      startDate = "",
      endDate = "",
      daysOfWeek = "",
      daysOfMonth = "",
      startDateTime = "", // computed
      endDateTime = "", // computed
    } = props;

    extendObservable(this, {
      id: id,
      userId: userId,
      propertyId: propertyId,
      name: name,
      passcode: passcode,
      enabled: enabled,
      notifySms: notifySms,
      notifyEmail: notifyEmail,
      type: type,
      startTime: startTime,
      endTime: endTime,
      startDate: startDate,
      endDate: endDate,
      daysOfWeek: daysOfWeek,
      daysOfMonth: daysOfMonth,
      startDateTime: startDateTime, // should be computed
      endDateTime: endDateTime, // should be computed
    });
  }

  set = action((props) => {
    if (!props) {
      return;
    }

    for (let key in props) {
      if (key in this) {
        this[key] = props[key];
      }
    }
  });

  get = () => {
    return JSON.parse(JSON.stringify(this));
  }
}

export default Passcode;


// WEBPACK FOOTER //
// ./src/models/Passcode.js